import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { inviteInfo, acceptInvite, formatApiError } from "@/auth";
import { AuthShell, Field, ErrorBox, PrimaryButton } from "@/components/AuthShell";

export default function AcceptInvite({ onAuthed }) {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [info, setInfo] = useState(null);
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    if (!token) return setError("This invitation link is missing its token.");
    inviteInfo(token).then((i) => { setInfo(i); setName(i.name || ""); }).catch((e) => setError(formatApiError(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return setError("Passwords do not match.");
    setBusy(true); setError("");
    try {
      const u = await acceptInvite({ token, password, name });
      onAuthed && onAuthed(u);
      nav("/", { replace: true });
    } catch (err) { setError(formatApiError(err)); } finally { setBusy(false); }
  };

  return (
    <AuthShell testId="accept-invite-screen" title="Join your team"
      subtitle={info ? `You've been invited to ${info.company} as ${info.role}. Set a password for ${info.email}.` : "Checking your invitation…"}>
      <form onSubmit={submit} className="space-y-3">
        <Field label="Your name" testId="invite-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Your full name" />
        <Field label="Password (8+ characters, letter and number)" testId="invite-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        <Field label="Confirm password" testId="invite-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
        <ErrorBox error={error} testId="invite-error" />
        <PrimaryButton testId="invite-submit" type="submit" disabled={busy || !info}>
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Set password &amp; sign in
        </PrimaryButton>
      </form>
      <p className="mt-5 text-center text-xs text-slate-500">
        Already set up? <Link to="/login" className="text-orange-400 hover:underline">Sign in</Link>
      </p>
    </AuthShell>
  );
}
